/* Workshops Navita (sections/navita-workshops*, navita-workshop; snippets/navita-workshop-estado).
   1. Contagem até à abertura das inscrições; quando chega a 0 volta a carregar a página (o Flow põe as vagas no stock).
   2. "Avisa-me" e "Lista de espera": aviso de reposição de stock do Klaviyo (o mesmo serve para a abertura, porque o stock
      está a 0 até abrir, e para as desistências).
   3. Quantidade (nunca mais do que as vagas livres) e inscrição: junta ao carrinho e abre o carrinho lateral.
   4. Miniaturas da foto. */
import { CartLinesUpdateEvent } from '@shopify/events';

if (!window.navitaWorkshopsPronto) {
  window.navitaWorkshopsPronto = true;
  const KLAVIYO = 'RSiHay';
  const lingua = document.documentElement.lang || '';
  const es = lingua.startsWith('es');
  const en = lingua.startsWith('en');
  const t = (pt, esp, ing) => (es ? esp : en ? ing : pt);
  const raiz = () => window.Shopify?.routes?.root || '/';
  const dinheiro = (centimos) => {
    try {
      return new Intl.NumberFormat(lingua || 'pt-PT', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' })
        .format(centimos / 100).replace(/[.,]00(?=\D*$)/, '');
    } catch { return (centimos / 100) + ' €'; }
  };

  /* 1. Contagem */
  const pad = (n) => String(n).padStart(2, '0');
  const contas = [...document.querySelectorAll('[data-nws-conta]')];
  let recarregar = false;
  function tic() {
    const agora = Date.now() / 1000;
    for (const c of contas) {
      const alvo = Number(c.dataset.nwsConta);
      let s = Math.max(0, Math.floor(alvo - agora));
      const v = { d: Math.floor(s / 86400), h: pad(Math.floor((s % 86400) / 3600)), m: pad(Math.floor((s % 3600) / 60)), s: pad(s % 60) };
      for (const [k, val] of Object.entries(v)) { const el = c.querySelector('[data-' + k + ']'); if (el) el.textContent = val; }
      if (alvo > 0 && s === 0 && !recarregar) {
        recarregar = true;
        setTimeout(() => { if (document.visibilityState === 'visible') location.reload(); else recarregar = false; }, 20000);
      }
    }
  }
  if (contas.length) { tic(); setInterval(tic, 1000); }

  /* 2. Avisos do Klaviyo */
  document.addEventListener('submit', async (e) => {
    const f = e.target.closest('[data-nws-aviso]');
    if (!f) return;
    e.preventDefault();
    const msg = f.querySelector('.nws-aviso__msg');
    const email = f.email.value.trim();
    msg.classList.remove('erro');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      msg.classList.add('erro');
      msg.textContent = t('Escreve um email válido.', 'Escribe un email válido.', 'Please enter a valid email.');
      return;
    }
    const botao = f.querySelector('button');
    botao.disabled = true;
    try {
      const r = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${KLAVIYO}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
        body: JSON.stringify({ data: {
          type: 'back-in-stock-subscription',
          attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email } } } },
          relationships: { variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${f.dataset.variante}` } } },
        } }),
      });
      if (!r.ok && r.status !== 202) throw new Error(r.status);
      f.classList.add('feito');
      msg.textContent = f.dataset.ok;
    } catch (erro) {
      botao.disabled = false;
      msg.classList.add('erro');
      msg.textContent = t('Não foi possível guardar. Tenta outra vez ou fala connosco no WhatsApp.',
        'No se ha podido guardar. Inténtalo de nuevo o escríbenos por WhatsApp.',
        "We couldn't save that. Please try again or message us on WhatsApp.");
    }
  });

  /* 3. Quantidade e inscrição */
  function acertar(form, n) {
    const max = Number(form.dataset.max) || 1;
    const campo = form.quantity;
    const q = Math.min(max, Math.max(1, Number.isFinite(n) ? n : 1));
    campo.value = q;
    const total = form.querySelector('[data-nws-total]');
    if (total) total.textContent = dinheiro(Number(form.dataset.preco) * q);
    return q;
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-nws-qtd]');
    if (!b) return;
    const form = b.closest('[data-nws-compra]');
    const pedido = Number(form.quantity.value) + Number(b.dataset.nwsQtd);
    const q = acertar(form, pedido);
    if (q < pedido) {
      const aviso = form.parentElement.querySelector('[data-nws-erro]');
      if (aviso) aviso.textContent = t(`Só há ${q} vagas livres.`, `Solo quedan ${q} plazas.`, `Only ${q} spots left.`);
    }
  });
  document.addEventListener('change', (e) => {
    const form = e.target.closest('[data-nws-compra]');
    if (form && e.target.name === 'quantity') acertar(form, Number(e.target.value));
  });
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-nws-compra]');
    if (!form) return;
    e.preventDefault();
    const id = Number(form.id.value);
    const quantidade = acertar(form, Number(form.quantity.value));
    form.classList.add('a-enviar');
    try {
      const r = await fetch(raiz() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: quantidade }] }),
      });
      const corpo = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(corpo.description || r.status);
      const promessa = CartLinesUpdateEvent.createPromise();
      form.dispatchEvent(new CartLinesUpdateEvent({
        action: 'add', context: 'product',
        lines: [{ merchandiseId: String(id), quantity: quantidade }],
        promise: promessa.promise,
      }));
      promessa.resolve({ detail: {} });
    } catch (erro) {
      const aviso = form.parentElement.querySelector('[data-nws-erro]');
      if (aviso) aviso.textContent = String(erro.message || erro);
    } finally {
      form.classList.remove('a-enviar');
    }
  });

  /* 4. Miniaturas */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-nws-mini]');
    if (!b) return;
    const foto = b.closest('.nws-ws__media')?.querySelector('[data-nws-foto]');
    if (!foto) return;
    foto.removeAttribute('srcset');
    foto.src = b.dataset.nwsMini;
    b.parentElement.querySelectorAll('button').forEach((x) => x.toggleAttribute('aria-current', x === b));
  });
}
